import { DEFAULT_PATHS } from './ApiUtils';
import { CATEGORIES } from './PermissionsChecker';

export const BUSINESS_DATA_TABS = [
  { key: 'stations', label: 'Airports', category: CATEGORIES.AIRPORTS },
  { key: 'regions', label: 'Regions', category: CATEGORIES.REGIONS },
  { key: 'countries', label: 'Countries', category: CATEGORIES.COUNTRIES },
  { key: 'cities', label: 'Cities', category: CATEGORIES.CITIES },
  { key: 'airlines', label: 'Airlines', category: CATEGORIES.AIRLINES },
  { key: 'geo-groups', label: 'Geo Groups', category: CATEGORIES.GEO_GROUPS },
];

export const getBusinessDataTabPath = (key: string) => `/${DEFAULT_PATHS.BUSINESS_DATA}/${key}`;